import { render, staticRenderFns } from "./ScreeningPlanAdd.vue?vue&type=template&id=81d479ac&scoped=true&"
import script from "./ScreeningPlanAdd.vue?vue&type=script&lang=js&"
export * from "./ScreeningPlanAdd.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningPlanAdd.vue?vue&type=style&index=0&id=81d479ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d479ac",
  null
  
)

export default component.exports